import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRequestApproval = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/request-approval/list?${queries}` });

  return data;
};

export default getRequestApproval;
